import { useState } from 'react';
import { Link, createFileRoute } from '@tanstack/react-router';
import { useMutation, useQuery } from '@tanstack/react-query';
import { api } from '../api/client';
import { q } from '../api/queries';
import { AuthLayout } from '@bounded/ui/auth-layout';
import { Button, Field, Input } from '@bounded/ui/primitives';
import { ErrorNotice } from '@bounded/ui/state';
import { useT } from '../i18n';

export const Route = createFileRoute('/forgot-password')({ component: Forgot });

function Forgot() {
  const t = useT(); const m = t.auth.forgot;
  const capabilities = useQuery(q.capabilities());
  const [email, setEmail] = useState('');
  const request = useMutation({ mutationFn: () => api.requestPasswordReset(email, '/reset-password') });
  if (capabilities.data && !capabilities.data.password_reset) {
    return <AuthLayout title={m.unavailableTitle}><p className="text-graphite">{m.unavailableBody}</p><Link to="/sign-in" className="text-boundary hover:underline">{m.back}</Link></AuthLayout>;
  }
  return (
    <AuthLayout title={m.title} footer={<Link to="/sign-in" className="text-boundary hover:underline">{m.back}</Link>}>
      {request.isSuccess ? (
        // The API answers the same way for unknown addresses, so the page does too.
        <p>{m.sent(email)}</p>
      ) : (
        <form className="grid gap-5" onSubmit={(e) => { e.preventDefault(); request.mutate(); }}>
          {request.error && <ErrorNotice error={request.error} onRetry={() => request.mutate()} />}
          <Field label={m.email} htmlFor="email"><Input id="email" type="email" autoComplete="email" required value={email} onChange={(e) => setEmail(e.target.value)} /></Field>
          <Button type="submit" variant="primary" disabled={request.isPending}>{m.submit}</Button>
        </form>
      )}
    </AuthLayout>
  );
}
